import { TableHeadersProps } from './TableHeaders.types';

export function TableHeaders({ selectedTab, ordersHeaderRef, historyHeaderRef }: TableHeadersProps) {
  if (selectedTab === 0) {
    return (
      <div className="orders-table-header-wrapper" ref={ordersHeaderRef}>
        <div className="orders-table-header">
          <div className="orders-header-cell orders-col-number">Порядковий номер</div>
          <div className="orders-header-cell orders-col-name">Назва</div>
          <div className="orders-header-cell orders-col-division">Дивізіон</div>
          <div className="orders-header-cell orders-col-entity">Юр. особа</div>
          <div className="orders-header-cell orders-col-date">Дата</div>
          <div className="orders-header-cell orders-col-download">Вивантаження</div>
        </div>
      </div>
    );
  }
  return (
    <div className="orders-table-header-wrapper" ref={historyHeaderRef}>
      <div className="history-table-header">
        <div className="history-header-cell history-col-division">Дивізіон</div>
        <div className="history-header-cell history-col-entity">Юр. особа</div>
        <div className="history-header-cell history-col-prev-number">Попередній №</div>
        <div className="history-header-cell history-col-new-number">Новий №</div>
        <div className="history-header-cell history-col-initiator">Ініціатор зміни</div>
        <div className="history-header-cell history-col-datetime">Дата та час зміни</div>
      </div>
    </div>
  );
}
